import { ReactNode } from "react";

import { useTranslator } from "@eo-locale/react";

import type { SystemStyleObject } from "@chakra-ui/react";

import ParticipantHeader from "@/components/participant-header";
import Footer from "@/components/footer";
import { Flex, SkipNavContent, SkipNavLink } from "@/storybook-components";
import useVisitsLogging from "@/hooks/useVisitsLogging";
import {
  EnhancedCookieConsent,
  LegacyCookieConsent
} from "@/components/cookie-consent/load-cookie-consent";

import ImageBanner from "../../image-banner";
import { useAppSelector } from "@/redux/store/hooks";

interface EHQLayoutProps {
  children: ReactNode;
  mainSx?: SystemStyleObject;
}

const EHQLayout = ({ children, mainSx }: EHQLayoutProps): JSX.Element => {
  useVisitsLogging();
  const { translate } = useTranslator();
  const { features } = useAppSelector((state) => state.features);
  const { nonce } = useAppSelector((state) => state.adapter.adapter);
  const isNewCookieConsentEnabled = features?.newCookieConsentManager?.enabled;

  const CookieConsent = isNewCookieConsentEnabled
    ? EnhancedCookieConsent
    : LegacyCookieConsent;

  return (
    <Flex flexDirection="column" minH="100vh">
      <CookieConsent />
      <SkipNavLink
        id="start-of-content"
        zIndex={1}
        data-testid="layout-skip-to-content-link"
      >
        {translate("common.skipToContent")}
      </SkipNavLink>
      <ParticipantHeader />
      <Flex
        as="main"
        flex={1}
        flexDirection="column"
        css={mainSx}
        data-testid="layout-main"
      >
        <ImageBanner />
        <SkipNavContent id="start-of-content" style={null} nonce={nonce} />
        {children}
      </Flex>
      <Footer />
    </Flex>
  );
};

export default EHQLayout;
